import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Menu, X } from "lucide-react";
import Logo from "./Logo";
import { scrollToId } from "../lib/scroll";

const LINKS = [
  { label: "Consultoria", id: "consultoria", testid: "nav-consulting-link" },
  { label: "Método", id: "metodo", testid: "nav-methodology-link" },
  { label: "Planos", id: "planos", testid: "nav-plans-link" },
  { label: "FAQ", id: "faq", testid: "nav-faq-link" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 border-b transition-colors duration-300 ${
        scrolled
          ? "border-white/10 bg-black/70 backdrop-blur-xl"
          : "border-transparent bg-transparent"
      }`}
    >
          <div className="container-x flex h-[72px] items-center justify-between">
        <Logo />

        <nav className="hidden items-center gap-8 md:flex">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={l.testid}
              onClick={() => go(l.id)}
              className="group relative font-mono text-[11px] uppercase tracking-[0.25em] text-white/60 transition-colors hover:text-white"
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 h-px w-0 bg-white transition-all duration-300 group-hover:w-full" />
            </button>
          ))}
          <button
            data-testid="nav-cta-button"
            onClick={() => go("contato")}
            className="inline-flex h-11 items-center bg-white px-6 font-display text-base font-bold uppercase tracking-wide text-black transition-all duration-300 hover:bg-neutral-200 hover:-translate-y-0.5"
          >
            Começar agora
          </button>
        </nav>

        <button
          data-testid="nav-menu-button"
          onClick={() => setOpen((v) => !v)}
          className="grid h-11 w-11 place-items-center border border-white/20 text-white md:hidden"
          aria-label="Abrir menu"
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
            className="overflow-hidden border-b border-white/10 bg-black/95 backdrop-blur-xl md:hidden"
          >
            <div className="container-x flex flex-col gap-1 py-6">
              {LINKS.map((l) => (
                <button
                  key={l.id}
                  onClick={() => go(l.id)}
                  className="border-b border-white/5 py-4 text-left font-display text-2xl font-bold uppercase tracking-wide text-white"
                >
                  {l.label}
                </button>
              ))}
              <button
                onClick={() => go("contato")}
                className="mt-4 inline-flex h-14 items-center justify-center bg-white font-display text-lg font-bold uppercase tracking-wide text-black"
              >
                Começar agora
              </button>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
}
